/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* Components */
import Search from './components/Search';

/* utilities */
import { parseDataToProps } from 'js/utilities';

const searchNodes = Array.from(document.querySelectorAll('[data-search]'));
[...searchNodes].forEach((node) => render(<Search {...parseDataToProps(node.dataset)} />, node));
